import logoBlackText from "../assets/images/logo-blck-text.png";

export default function ClinicPortalRefreshLoader() {
  return (
    <div className="clinic-refresh-loader" role="status" aria-live="polite">
      <style>{`
        .clinic-refresh-loader {
          min-height: 100dvh;
          display: grid;
          place-items: center;
          padding: 24px;
          box-sizing: border-box;
          background: linear-gradient(180deg, #f5f9ff 0%, #eaf2fd 100%);
          color: #0d2358;
        }

        .clinic-refresh-loader__content {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 18px;
          text-align: center;
        }

        .clinic-refresh-loader__logo {
          display: block;
          width: min(58vw, 220px);
          height: auto;
          object-fit: contain;
        }

        .clinic-refresh-loader__spinner {
          width: 30px;
          height: 30px;
          border: 3px solid rgba(31, 99, 242, 0.18);
          border-top-color: #1f63f2;
          border-radius: 50%;
          animation: clinic-refresh-spin 0.8s linear infinite;
        }

        .clinic-refresh-loader__text {
          margin: 0;
          font: 500 15px/1.4 Manrope, Inter, sans-serif;
          color: #66779c;
        }

        @keyframes clinic-refresh-spin {
          to { transform: rotate(360deg); }
        }

        @media (prefers-reduced-motion: reduce) {
          .clinic-refresh-loader__spinner { animation: none; }
        }
      `}</style>
      <div className="clinic-refresh-loader__content">
        <img
          src={logoBlackText}
          alt="CliniQueue"
          className="clinic-refresh-loader__logo"
        />
        <span className="clinic-refresh-loader__spinner" aria-hidden="true" />
        <p className="clinic-refresh-loader__text">Loading your clinic workspace...</p>
      </div>
    </div>
  );
}
